'use client'

import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import { useTranslations } from 'next-intl'
import Image from 'next/image'

const cards = [
  { key: 'item1', image: '/image/2026/10/21/ph_feature_1.jpg' },
  { key: 'item2', image: '/image/2026/10/21/ph_feature_2.jpg' },
  { key: 'item3', image: '/image/2026/10/21/ph_feature_3.jpg' },
  { key: 'item4', image: '/image/2026/10/21/ph_feature_4.jpg' },
]

const MOBILE_AUTOPLAY = {
  delay: 3000,
  stopOnInteraction: false,
  breakpoints: { '(min-width: 768px)': { active: false } },
}

/** 4 card tính năng sản phẩm: mobile slide ngang tự chạy, desktop 4 card cố định 1 hàng */
export const PhucHuynhFeatures = () => {
  const t = useTranslations('phuc_huynh_hardcode.features')

  return (
    <section className='bg-black px-5 py-10 md:p-10 2xl:p-15'>
      <Carousel
        opts={{
          align: 'start',
          loop: true,
          breakpoints: { '(min-width: 768px)': { active: false } },
        }}
        plugins={[Autoplay(MOBILE_AUTOPLAY)]}
        className='max-md:-mr-5'
      >
        <CarouselContent className='-ml-4 md:-ml-3 2xl:-ml-5'>
          {cards.map((card) => (
            <CarouselItem
              key={card.key}
              // Card không click được → bỏ cursor-pointer mặc định của CarouselItem
              className='basis-[230px] cursor-default pl-4 md:basis-1/4 md:pl-3 2xl:pl-5'
            >
              <div className='relative flex aspect-[435/558] flex-col justify-end gap-1 overflow-hidden rounded-2xl px-3 py-4 2xl:px-5 2xl:py-6'>
                <Image
                  src={ImageHelper.getImageUrlCdn(card.image)}
                  alt={t.markup(`${card.key}.title`, {
                    br: () => ' ',
                    tm: (chunks) => chunks,
                  })}
                  fill
                  sizes='(min-width: 768px) 23vw, 210px'
                  className='object-cover'
                />
                {/* Figma: gradient đen 67% phủ 211/558 chiều cao card */}
                <div className='absolute inset-x-0 bottom-0 h-[56%] bg-gradient-to-b from-transparent to-black/70 md:h-[38%] md:to-black/[0.67]' />
                <p className='relative font-criteria text-lg font-medium uppercase text-white md:text-base 2xl:text-2xl'>
                  {t.rich(`${card.key}.title`, {
                    // Ký hiệu ™ dùng font sans thay vì Criteria
                    tm: (chunks) => <span className='font-sans'>{chunks}</span>,
                    // Chỉ xuống dòng trên mobile, desktop giữ 1 dòng
                    br: () => (
                      <>
                        {' '}
                        <br className='md:hidden' />
                      </>
                    ),
                  })}
                </p>
                <p className='relative text-xs text-white 2xl:text-base'>
                  {t(`${card.key}.description`)}
                </p>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    </section>
  )
}
